module.exports = __webpack_public_path__ + "img/Roof Fastener Spacing.a5e7def2.jpg";